import { createContext, useContext, Dispatch, SetStateAction } from 'react';
import { CookiesConsentType } from 'types/CookiesConsentType';

export type CookieConsentContextProps = {
  cookiesConsent: CookiesConsentType;
  setCookiesConsent: Dispatch<SetStateAction<CookiesConsentType>>;
  cookieBannerChecked: boolean;
  toggleCookieBannerChecked: Dispatch<SetStateAction<boolean>>;
};

export const CookieConsentContext = createContext<CookieConsentContextProps>({
  cookiesConsent: {
    essential: true,
    functional: false,
    analytics: false,
    marketing: false,
    social: false,
  },
  setCookiesConsent: () => {},
  cookieBannerChecked: false,
  toggleCookieBannerChecked: () => {},
});

export const useCookieConsent = () => useContext(CookieConsentContext);
